import { de } from '@3pc/lightbox-photoswipe/lib/lang/de';
import { $ } from '../../../shared/js/utils/dom';

export const config = {
  mainClass: 'pswp--duk',
  bgOpacity: 1,
  loop: false,
  zoom: true,
  initialZoomLevel: 'fit',
  secondaryZoomLevel: 'fill',

  paddingFn: viewportSize => {
    return {
      top: viewportSize.x < 600 ? 100 : 210,
      bottom: viewportSize.x < 600 ? 100 : 210,
      left: 0,
      right: 0,
    };
  },
  closeSVG: `
    <span class="icon icon--close">
      <svg class="icon__svg" role="img" aria-hidden="true">
        <use href="#icon-close"></use>
      </svg>
      <span class="sr-only">${de.closeTitle}</span>
    </span>
  `,
  arrowPrevSVG: `
    <span class="icon icon--arrow-left-thick">
      <svg class="icon__svg" role="img" aria-hidden="true">
        <use href="#icon-arrow-left"></use>
      </svg>
      <span class="sr-only">${de.arrowPrevTitle}</span>
    </span>
  `,
  arrowNextSVG: `
    <span class="icon icon--arrow-right-thick">
      <svg class="icon__svg" role="img" aria-hidden="true">
        <use href="#icon-arrow-right"></use>
      </svg>
      <span class="sr-only">${de.arrowNextTitle}</span>
    </span>
  `,
  appendUIElementsToBottom: ['counter', 'arrowPrev', 'arrowNext'],
  defaultDialogTitle: 'Galerie Detailansicht',
  showCopyrightUnderCaption: true,
  disableOnClickZoom: false,
};

export const fixCounter = instance => {
  instance.pswpLightboxInstance.on('change', () => {
    const pswp = instance.pswpLightboxInstance.pswp;
    const counter = pswp.element.querySelector('.pswp__counter');
    const counterStr = `<span class="pswp__counter-inner"><span class="pswp__counter-current">${
      pswp.currIndex + 1
    }</span> <span aria-hidden="true">|</span><span class="sr-only">${
      pswp.options.indexIndicatorSep
    }</span> ${pswp.getNumItems()}</span>`;

    counter.classList.add('pswp__counter--has-fix');

    setTimeout(() => {
      counter.innerHTML = counterStr;
    }, 0);
  });
};

export const addZoomIcons = instance => {
  instance.pswpLightboxInstance.on('change', () => {
    const buttonPswp = $('.pswp__button--zoom');

    const svgZoomIcons = `<svg class="icon__svg icon__svg--zoom-plus" viewBox="0 0 24 24" preserveAspectRatio="xMidYMid meet">
    <path d="M19.4156 18.2513a11.0448 11.0448 0 0 0-.8644-15.3106 11.0448 11.0448 0 0 0-15.3318.3124 11.0445 11.0445 0 0 0-.24 15.333 11.044 11.044 0 0 0 15.3139.7923l4.6039 4.6039 1.106-1.106-4.5876-4.625Zm-1.6299-.5292a9.4775 9.4775 0 0 1-16.1762-6.7046 9.477 9.477 0 0 1 2.7749-6.7007 9.4775 9.4775 0 0 1 13.4013-.004 9.4193 9.4193 0 0 1-.0212 13.4145l.0212-.0052Z" fill="currentColor"/>
    <path d="M11.8429 5.545h-1.5664v4.6939h-4.694v1.5664h4.694v4.6885h1.5664v-4.6885h4.694v-1.5664h-4.694v-4.694Z" fill="currentColor"/>
  </svg>
  <svg class="icon__svg icon__svg--zoom-minus" viewBox="0 0 24 24" preserveAspectRatio="xMidYMid meet">
    <path d="M19.4124 18.2513a11.0448 11.0448 0 0 0-.8644-15.3106 11.0448 11.0448 0 0 0-15.3317.3124 11.0445 11.0445 0 0 0-.24 15.333 11.044 11.044 0 0 0 15.3139.7923l4.6038 4.6039L24 22.8763l-4.5876-4.625Zm-1.6299-.5292a9.4778 9.4778 0 0 1-16.1762-6.7046 9.477 9.477 0 0 1 2.775-6.7007 9.4775 9.4775 0 0 1 13.4013-.004 9.4193 9.4193 0 0 1-.0213 13.4145l.0212-.0052Z" fill="currentColor"/>
    <path d="m11.5 10.2393-.8268.0003-.3998-.0003h-4.694v1.5663h10.9544v-1.5663H11.5Z" fill="currentColor"/>
  </svg>`;

    buttonPswp.innerHTML = svgZoomIcons;
  });
};
